<template>
<v-container>
  
  
  <v-dialog
    v-model="loading"
    hide-overlay
    persistent
    width="300"
    >
    <v-card
      color="red"
      dark
      >
      <v-card-text>
        Please stand by
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
          ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
  
  
  
  <div
    class="mx-auto"
    v-for="client in summary"
    :key="client.client"
    >
    <h1>{{ client.client }}</h1>
    
    <v-row>
      <v-col md="9">
	<calendar-heatmap
	  :range-color="['#303030', '#F44336', '#FF9800', '#FFEB3B', '#4CAF50']"
	  :values="client.reports"
	  :max="100"
	  :endDate="wantedreportdate"
	  tooltip-unit="%"
	  />
      </v-col>
      
      
      <v-col md="3">
	<div class="mygauge">
	  <v-gauge :value="client.total" height="150" :minValue="minValue" :maxValue="maxValue" :options="gaugeOpts"/>
	</div>
      </v-col>
    </v-row>     
    
  </div>
  
</v-container>
</template>

<script>
import { CalendarHeatmap } from 'vue-calendar-heatmap';
import VGauge from "vgauge";

import { config } from '../config';


export default {
    components: {
        CalendarHeatmap,
	VGauge,
    },
    
    props: {
	wantedreportdate: String
    },
    
    data: () => ({
        loading: true,
	errorState: false,
	booltrue: true,
        summary: {},
	minValue: 0,
	maxValue: 100,
	gaugeOpts: {
	    angle: -0.26,
	    lineWidth: 0.1,
	    colorStart: '#303030',
	    colorStop: '#303030',
	    background: '#303030',
	    strokeColor: '#303030',
	    percentColors: [[0.0, "#F44336" ], [0.60, "#FF9800"], [0.90, "#FFEB3B"], [1.0, "#4CAF50"]],
	    pointer: {
		length: 0.42,
		strokeWidth: 0.064,
		color: '#000000'
	    },
	    renderTicks: {
		divisions: 10,
		divWidth: 1.1,
		divLength: 1,
		divColor: '#333333',
		subDivisions: 3,
		subLength: 0.5,
		subWidth: 0.6,
		subColor: '#666666'
	    },
	    staticLabels: {
		font: "15px sans-serif",  // Specifies font
		labels: [10, 20, 30, 40, 50, 60, 70, 80, 90],  // Print labels at these values
		color: "#FFF",  // Optional: Label text color
		fractionDigits: 0  // Optional: Numerical precision. 0=round off.
	    },

	},
    }),
    
    created() {
	this.loadSummData();
    },
    
    watch: {
    },
    
    computed: {
    },
    
    methods: {
	loadSummData() {
	    this.loading = true;
            const urlSumm = `${config.baseUrl}deliveries/summary`;
	    
            this.$http.get(urlSumm, { auth: this.$store.getters.auth }).then((res) => {
                this.summary = res.data;
                this.loading = false;
		this.summary.forEach(s => {
		    s.reports.forEach(r => {
			if (r.count === 0) {
			    r.count = 0.000001;
			}
		    });
		});

		this.summary.forEach(s => {
		    s.total = 0;

		    s.reports.forEach(sr => {
			s.total += sr.count;
		    });

		    s.total = s.total / s.reports.length;
		});
            }).catch((err) => {
                console.log(err);
            });
	},
    },
};
</script>

<style lang="scss" scoped>
canvas {
    background-color: red;
    height: 100px !important;
}
</style>
